import { render } from "./modal-import-message-setting-user-hcbp.vue?vue&type=template&id=5f95d890"
import script from "./modal-import-message-setting-user-hcbp.vue?vue&type=script&lang=js"
export * from "./modal-import-message-setting-user-hcbp.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__